// extracted by mini-css-extract-plugin
export var smallSpinner = "_wx-0";